import { useState } from 'react'

import {
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled
} from 'components'
import { EditIcon, DeleteIcon } from 'components/Icons'
import { useModal } from 'hooks'
import { MotivosBloqueioInterface } from 'services/NGT/RecordsSheet'
import { SPACING } from 'utils'

interface ITableWorkSafety {
  tableData: MotivosBloqueioInterface[]
  handleEditMotivo: (_motivoBloqueio: MotivosBloqueioInterface) => void
  handleDeleteMotivo: (_idMotivoBloqueio: number) => void
}
export const BlockTable = ({
  tableData,
  handleDeleteMotivo,
  handleEditMotivo
}: ITableWorkSafety) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(15)
  const { showModal } = useModal()

  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }
  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled minwidth="300px" align="left">
                Motivo
              </TableCellStyled>
              <TableCellStyled minwidth="300px" align="left">
                Descrição
              </TableCellStyled>
              <TableCellStyled minwidth="150px" align="left">
                Tipo
              </TableCellStyled>
              <TableCellStyled align="left" minwidth="100px">
                Ações
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {(rowsPerPage > 0
              ? tableData.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : tableData
            ).map((row) => (
              <TableRowStyled key={row.idMotivoBloqueio}>
                <TableCellStyled align="left">{row.txMotivo}</TableCellStyled>
                <TableCellStyled align="left">
                  {row.txDescricao}
                </TableCellStyled>
                <TableCellStyled align="left">{row.txTipo}</TableCellStyled>
                <TableCellStyled align="center">
                  <EditIcon
                    onClick={() => handleEditMotivo(row)}
                    marginLeft={SPACING.spacing15}
                    marginRight={SPACING.spacing15}
                    cursor="pointer"
                  />
                  <DeleteIcon
                    onClick={() =>
                      showModal({
                        handleConfirm: () =>
                          handleDeleteMotivo(row.idMotivoBloqueio),
                        message: 'Confirma exclusão (S/N)?',
                        txtButtonCancel: 'NÃO',
                        txtButtonConfirm: 'SIM',
                        type: 'alert'
                      })
                    }
                    cursor="pointer"
                  />
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="offline"
      />
    </>
  )
}
